<template>
  <div class="font-sans text-base relative text-neutral2-800">
    <slot/>
  </div>
</template>
